import styled, { css } from "styled-components";
import { fontNormal, fontMedium } from "../../_static/Typography";
import ButtonDefault from "../../_atom/Buttons/default";

import buildColor from "../../_static/ColorPalette";

const FontStyling = css`
  font-size: 14px;
  line-height: 18px;
  color: ${buildColor("grey", "900")};
`;

export const Container = styled.section`
  background-color: ${buildColor("white", "100")};
  padding: 16px 8px;
  overflow-x: hidden;
  word-break: break-word;

  h3 {
    font-family: ${fontMedium};
    ${FontStyling}
  }

  p {
    font-family: ${fontNormal};
    font-size: 14px;
    font-stretch: normal;
    letter-spacing: normal;
    line-height: 18px;
    color: ${buildColor("grey", "900")};
    margin: 24px 0;

    strong {
      font-family: ${fontMedium};
      ${FontStyling}
    }

    a,
    span,
    strong {
      display: inline-block;
      vertical-align: baseline;
    }
  }

  .mobileView {
    > h1 {
      display: none;
    }

    a {
      text-decoration: none;
    }

    > p:first-of-type {
      margin: 0 0 24px;
      text-align: left !important;
      color: ${buildColor("grey", "700")};
    }
  }

  .privacypolicy {
    p {
      margin: 0 0 24px;
    }
  }

  .privatePolicyMobile,
  .showMobile {
    display: ${({ isMobile }) => (isMobile ? "inline" : "none")};
  }

  .privatePolicyDesktop,
  .showDesktop {
    display: ${({ isMobile }) => (!isMobile ? "inline" : "none")};
  }
`;

export const ContentButton = styled(ButtonDefault)`
  display: inline-block;
  vertical-align: baseline;
  color: ${buildColor("blue_accent", "500")};
  font-size: 14px;
  line-height: 18px;
`;
